module.exports = __webpack_public_path__ + "static/img/about_zhuzq06.c10ea2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq06.png
// module id = Ugte
// module chunks = 1